import { createContext, useContext, useState, useEffect } from 'react';
import { startTimer } from '../utils/timer';

const UIContext = createContext();

export const UIProvider = ({ children }) => {
    // Состояние для дропдаунов
    const [dropdowns, setDropdowns] = useState([]);
    // Состояние для модального окна (true - открыто, false - закрыто)
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Состояние для активного пункта навигации
    const [activeNavItem, setActiveNavItem] = useState('rewards'); // По умолчанию активен 'rewards'

    const [selectedWallet, setSelectedWallet] = useState(null);

    const [userData, setUserData] = useState([]);

    const [timers, setTimers] = useState({});
    // Счётчик для генерации timerId
    const [timerCount, setTimerCount] = useState(0);

    const [timerWallets, setTimerWallets] = useState({});

    const [secondTimer, setSecondTimer] = useState(3600); // Начальное значение: 1 час (3600 секунд)

    const [assetId, setAssetId] = useState({levels: []});

    const [submitBtnState, setSubmitBtnState] = useState(true);

    const [rewardValueName, setRewardValueName] = useState('');


    // Константа длительности таймера
    const TIMER_DURATION = 10 * 60; // 10 минут в секундах
    const SECOND_TIMER_DURATION = 3600; // 1 час в секундах
    const SECOND_TIMER_ID = 'secondTimer'; // Уникальный ID для второго 


    // Восстановление selectedWallet и timerWallets из localStorage
    useEffect(() => {
        const savedSelectedWallet = localStorage.getItem('selectedWallet');
        if (savedSelectedWallet) {
            setSelectedWallet(JSON.parse(savedSelectedWallet));
            console.log('Restored selectedWallet:', JSON.parse(savedSelectedWallet));
        } else {
            localStorage.removeItem('selectedWallet');
            console.log('Cleared selectedWallet from localStorage');
        }

        const savedTimerWallets = localStorage.getItem('timerWallets');
        if (savedTimerWallets) {
            setTimerWallets(JSON.parse(savedTimerWallets));
            console.log('Restored timerWallets:', JSON.parse(savedTimerWallets));
        }

        const savedSecondTimer = localStorage.getItem('secondTimer');
        if (savedSecondTimer) {
            const time = parseInt(savedSecondTimer, 10);
            setSecondTimer(time > 0 ? time : SECOND_TIMER_DURATION);
            console.log('Restored secondTimer:', time);
        }
    }, []);

    // Запуск второго таймера
    // useEffect(() => {
    //     const stopSecondTimer = startTimer(SECOND_TIMER_ID, SECOND_TIMER_DURATION, (seconds) => {
    //         setSecondTimer(seconds);
    //         if (seconds <= 0) {
    //             // Рестарт таймера
    //             console.log('Restarting second timer');
    //             startTimer(SECOND_TIMER_ID, SECOND_TIMER_DURATION, setSecondTimer);
    //         }
    //     });

    //     return () => stopSecondTimer(); // Очистка при размонтировании
    // }, []);

    // Сохранение selectedWallet в localStorage
    useEffect(() => {
        if (selectedWallet) {
            localStorage.setItem('selectedWallet', JSON.stringify(selectedWallet));
            console.log('Saved selectedWallet:', selectedWallet);
        }
    }, [selectedWallet]);

    // Сохранение timerWallets в localStorage
    useEffect(() => {
        localStorage.setItem('timerWallets', JSON.stringify(timerWallets));
        console.log('Saved timerWallets:', timerWallets);
    }, [timerWallets]);

    // Логирование изменений состояний для отладки
    useEffect(() => {
        console.log('Current dropdowns:', dropdowns);
    }, [dropdowns]);

    useEffect(() => {
        console.log('Modal open:', isModalOpen);
    }, [isModalOpen]);

    useEffect(() => {
        console.log('Active nav item:', activeNavItem);
    }, [activeNavItem]);

    useEffect(() => {
        console.log('Timers:', timers);
    }, [timers]);

    useEffect(() => {
        console.log('Second timer:', secondTimer);
    }, [secondTimer]);


    

    // Управление дропдаунами
    const toggleDropdown = (idObj) => {
        const id = typeof idObj === 'object' && idObj.id ? idObj.id : idObj;
        setDropdowns((prev) => {
            const exists = prev.find((d) => d.id === id);
            if (exists) {
                return prev.map((d) =>
                    d.id === id ? { ...d, isOpen: !d.isOpen } : d
                );
            } else {
                return [...prev, { id, isOpen: true }];
            }
        });
    };

    const closeAllDropdowns = () => {
        setDropdowns((prev) => prev.map((d) => ({ ...d, isOpen: false })));
    };

    const isDropdownOpen = (idObj) => {
        const id = typeof idObj === 'object' && idObj.id ? idObj.id : idObj;
        return dropdowns.find((d) => d.id === id)?.isOpen || false;
    };

    // Управление модальным окном
    const openModal = () => {
        setIsModalOpen(true);
        document.body.classList.add('no-scroll');
    };

    const closeModal = () => {
        setIsModalOpen(false);
        document.body.classList.remove('no-scroll');
    };

    // Управление активным пунктом навигации
    const setNavItemActive = (id) => {
        setActiveNavItem(id);
    };

    // Запуск первого таймера
    const startNewTimer = (timerId, walletAddress = null) => {
        if (timers[timerId] > 0) {
            console.log(`Timer ${timerId} already active with ${timers[timerId]} seconds`);
            return timerId;
        }

        setTimerWallets((prev) => ({
            ...prev,
            [timerId]: walletAddress,
        }));

        const stopTimer = startTimer(timerId, TIMER_DURATION, (seconds) => {
            setTimers((prev) => {
                const newTimers = { ...prev, [timerId]: seconds };
                if (seconds <= 0) {
                    delete newTimers[timerId];
                    setTimerWallets((prevWallets) => {
                        const newWallets = { ...prevWallets };
                        delete newWallets[timerId];
                        return newWallets;
                    });
                }
                return newTimers;
            });
        });

        return timerId;
    };

    


    return (
        <UIContext.Provider
            value={{
                dropdowns,
                toggleDropdown,
                closeAllDropdowns,
                isDropdownOpen,
                isModalOpen,
                openModal,
                closeModal,
                activeNavItem,
                setNavItemActive,
                selectedWallet,
                setSelectedWallet,
                userData,
                setUserData,
                timers,
                startNewTimer,
                timerWallets,
                secondTimer,
                assetId,
                setAssetId,
                submitBtnState,
                setSubmitBtnState,
                rewardValueName,
                setRewardValueName
            }}
        >
            {children}
        </UIContext.Provider>
    );
};

export const useUI = () => useContext(UIContext);